import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/waveform.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...n,
	children: [
		/* @__PURE__ */ e("path", {
			fill: "#fff",
			d: "M8.75 1.25a1.25 1.25 0 1 1 2.5 0v16.21a1.25 1.25 0 1 1-2.5 0z"
		}),
		/* @__PURE__ */ e("path", {
			fill: "#fff",
			d: "M13.125 3.975a1.25 1.25 0 1 1 2.5 0v10.752a1.25 1.25 0 0 1-2.5 0z"
		}),
		/* @__PURE__ */ e("path", {
			fill: "#fff",
			d: "M17.5 7.5a1.25 1.25 0 1 1 2.5 0v3.71a1.25 1.25 0 1 1-2.5 0z"
		}),
		/* @__PURE__ */ e("path", {
			fill: "#fff",
			d: "M4.375 3.975a1.25 1.25 0 1 1 2.5 0v10.752a1.25 1.25 0 0 1-2.5 0z"
		}),
		/* @__PURE__ */ e("path", {
			fill: "#fff",
			d: "M0 7.5a1.25 1.25 0 1 1 2.5 0v3.71a1.25 1.25 0 1 1-2.5 0z"
		})
	]
});
//#endregion
export { n as default };
